import { useCallback } from 'react';

import { useFeature } from 'hooks/useFeature';
import { useTranslate } from 'hooks/useTranslations';
import { usePdp } from 'hooks/usePdp';
import { useProductCustomization } from 'hooks/useProductCustomization';
import { CustomizeProductSwitch } from 'ui/components/CustomizeProductSwitch';

export const ProductCustomizer = () => {
  const translate = useTranslate();
  const { variation } = usePdp();
  const customizationEnabled = useFeature('MY_CUSTOMIZER');
  const {
    userProductCustomization,
    clearUserProductCustomization,
    startCustomization,
  } = useProductCustomization();

  const startProductCustomization = useCallback(
    () => startCustomization(),
    [startCustomization]
  );

  if (!(customizationEnabled && variation?.myCustomizer?.enabled)) return null;

  return (
    <>
      <div className="space-y-6">
        <h2 className="font-bold text-xl">{translate('customization')}</h2>
        <CustomizeProductSwitch
          productCustomization={userProductCustomization}
          onClick={startProductCustomization}
          onClear={() => {
            clearUserProductCustomization();
          }}
        />
      </div>
      <hr />
    </>
  );
};
